<div class="credit-info-container flex flex-column gap-3 mb-5">
  <div class="flex flex-column gap-3">
    <div>
      <span class="title">{{ secureDataPageTitle() | translate }}</span>
    </div>
    <p-divider></p-divider>
    @if (creditCheckRequired()) {
      <div class="title text-base font-semibold">
        <app-translate key="CUSTOMER_CONSENT"></app-translate>
      </div>
      <div>
        <div [innerHTML]="legalDescription"></div>
      </div>
      <div class="flex flex-row gap-3 align-content-center">
        <p-checkbox inputId="isConsentAgreed" (ngModelChange)="onConsentChecked($event)"
          [(ngModel)]="isConsentAgreed" [binary]="true" />
        <label for="isConsentAgreed" class="text-base font-light mb-0">
          <app-translate key="READ_AND_AGREE"></app-translate>
        </label>
      </div>
      <p-divider></p-divider>
    }
  </div>
  @if (creditInformationForm) {
    <div>
      <fieldset [disabled]="!isConsentAgreed" class="p-0 border-none">
        <sp-form-wrapper [formGroup]="creditInformationForm" id="customerInformationForm">
          <!-- Customer Information Form -->
          <div class="flex flex-column gap-3" formGroupName="customerInfoGroup">
            <div class="title text-base font-semibold">
              <app-translate key="CUSTOMER_INFORMATION"></app-translate>
            </div>
            <!-- Firstname Control -->
            <div class="col-12 md:col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="firstName" class="form-label required"><app-translate
                key="FIRST_NAME"></app-translate></label>
                <input type="text" [placeholder]="languageService.getTranslation('FIRST_NAME')" pInputText
                  formControlName="firstName" class="mb-1 skinny w-full sara-error"
                  (focus)="sendCustomerInputMessage('first name')" [readOnly]="creditChecked()" />
                <sp-control-error [parameters]="[languageService.getTranslation('FIRST_NAME')]"
                  [messagesParameters]="[{key : 'pattern', message : languageService.getTranslation('ENTER_VALID_FIRST_NAME')}]"
                [control]="customerInfoGroup.controls['firstName']"></sp-control-error>
              </div>
            </div>
            <!-- Lastname Control -->
            <div class="col-12 md:col-6">
              <div class="flex flex-column flex-1">
                <label htmlFor="lastName" class="form-label required"><app-translate
                key="LAST_NAME"></app-translate></label>
                <div class="flex align-items-center">
                  <input type="text" [placeholder]="languageService.getTranslation('LAST_NAME')"
                    pInputText formControlName="lastName" class=" w-full flex-1 mb-0 skinny sara-error"
                    (focus)="sendCustomerInputMessage('last name')" [readOnly]="creditChecked()" />
                </div>
                <sp-control-error [parameters]="[languageService.getTranslation('LAST_NAME')]"
                  [control]="customerInfoGroup.controls['lastName']"
                [messagesParameters]="[{key : 'pattern', message : languageService.getTranslation('ENTER_VALID_LAST_NAME')}]"></sp-control-error>
              </div>
            </div>
            <!-- Phone Control -->
            <div class="col-12 md:col-6">
              <div class="flex">
                <app-phone-verification class="flex-auto" styleClass="flex-auto"
                  [control]="customerInfoGroup.controls['phone']" [controlName]="'phone'"
                  [formGroupRef]="customerInfoGroup" [showSearchIcon]="false"
                  (ChangeInputFocus)="sendCustomerInputMessage('phone')"
                (verificationStatus)="onApiPhoneValidation($event)" [showLabel]="true" [hideValidatePhone]="false"></app-phone-verification>
              </div>
            </div>
            <!-- Email Control -->
            <div class="col-12 md:col-6">
              <div class="flex">
                <app-email-verification class="flex-auto" styleClass="flex-auto"
                  [control]="customerInfoGroup.controls['email']" [controlName]="'email'"
                  [formGroupRef]="customerInfoGroup" [showSearchIcon]="false"
                  (ChangeInputFocus)="sendCustomerInputMessage('email')"
                (verificationStatus)="onApiEmailValidation($event)" [showLabel]="true" [hideValidatePhone]="false"></app-email-verification>
              </div>
            </div>
            <!-- Business Name Control (SMB) -->
            @if (isSMB) {
              <div class="col-12 md:col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="businessName" class="form-label required">
                    <app-translate key="BUSINESS_NAME"></app-translate>
                  </label>
                  <input type="text" [placeholder]="'ENTER_BUSINESS_NAME' | translate" pInputText
                    formControlName="businessName" class="mb-1 skinny w-full sara-error" maxlength="200"
                    (focus)="sendCustomerInputMessage('business name')" [readOnly]="creditChecked()" />
                  <sp-control-error [parameters]="['BUSINESS_NAME' | translate]"
                  [control]="customerInfoGroup.controls['businessName']"></sp-control-error>
                </div>
              </div>
            }
            <div class="border-round-lg col-12 px-3 py-2" style="background-color: #FEF8E4;">
              <div class="col-12">
                <span class="text-sm font-light mb-0"><app-translate
                key="VERIFY_INFORMATION_WARNING"></app-translate></span>
              </div>
              <div class="col-12">
                <div class="flex flex-row gap-2 align-content-center">
                  <p-checkbox inputId="verifyCustomerInformation"
                    formControlName="verifyCustomerInformation" [binary]="true"
                    (onFocus)="sendCustomerInputMessage('Customer is checking verifying information', false)" />
                  <label for="verifyCustomerInformation" class="text-base font-light required">
                    <app-translate key="VERIFIED_INFORMATION"></app-translate>
                  </label>
                </div>
                @if (customerInfoGroup.controls['verifyCustomerInformation'].invalid) {
                  <div class="mt-2">
                    <sp-control-error [parameters]="[languageService.getTranslation('CHECKBOX')]"
                      [control]="customerInfoGroup.controls['verifyCustomerInformation']"
                    [messagesParameters]="[{key : 'pattern', message : languageService.getTranslation('ENTER_VALID_SSN')}]"></sp-control-error>
                  </div>
                }
              </div>
            </div>
            <!-- Passcode section -->
            @if (passcodeRequired()) {
              <div class="flex flex-column gap-3">
                <p-divider></p-divider>
                <div class="title text-base font-semibold">
                  <app-translate key="CREATE_PASSCODE"></app-translate>
                </div>
                <div>
                  <span class="font-light text-sm"><app-translate
                  key="CREATE_PASSCODE_SECURE"></app-translate></span>
                </div>
                <div>
                  <span class="font-semibold text-sm" style="color: #385DA4"><app-translate
                  key="CREATE_PASSCODE_REQ"></app-translate></span>
                </div>
                <div class="col-12 md:col-6 flex flex-column flex-1">
                  <label htmlFor="enterPasscode" class="form-label required"><app-translate
                  key="ENTER_PASSCODE"></app-translate></label>
                  <input pInputText [maxLength]="8" placeholder="enter passcode" formControlName="passcode"
                    class="w-full skinny app-text-masked" (keypress)="onKeyPressAllowOnlyDigits($event)" />
                  @if (customerInfoGroup.get('passcode')?.touched &&
                    customerInfoGroup.get('passcode')?.errors) {
                    <div class="p-error text-left">
                      {{getPasscodeErrorMessage(customerInfoGroup.get('passcode'))}}
                    </div>
                  }
                  @if (customerInfoGroup.get('passcode')?.errors?.['passwordMismatch'] &&
                    customerInfoGroup.get('passcode')?.touched) {
                    <div class="p-error text-left">
                      Passcodes do not match
                    </div>
                  }
                </div>
                <div class="col-12 md:col-6 flex flex-column flex-1">
                  <label htmlFor="confirmPasscode" class="form-label required"><app-translate
                  key="CONFIRM_PASSCODE"></app-translate></label>
                  <input pInputText [maxLength]="8" placeholder="enter passcode"
                    formControlName="confirmPasscode" class="w-full skinny app-text-masked"
                    (keypress)="onKeyPressAllowOnlyDigits($event)" />
                  @if (customerInfoGroup.get('confirmPasscode')?.touched &&
                    customerInfoGroup.get('confirmPasscode')?.errors) {
                    <div class="p-error text-left">
                      {{getPasscodeErrorMessage(customerInfoGroup.get('confirmPasscode'))}}
                    </div>
                  }
                  @if (customerInfoGroup.get('confirmPasscode')?.errors?.['passwordMismatch'] &&
                    customerInfoGroup.get('confirmPasscode')?.touched) {
                    <div class="p-error text-left">
                      Passcodes do not match
                    </div>
                  }
                </div>
                <p-divider></p-divider>
              </div>
            }
          </div>
          <!-- Credit Information Form -->
          @if (showCreditInformationSection()) {
            <div class="flex flex-column gap-3" formGroupName="creditInfoGroup"
              >
              <div class="title text-base font-semibold pt-3">{{ secureDataCreditSectionName() | translate }}</div>
              @if (creditOnFile()) {
                <div class="col-12 font-semibold">
                  <app-translate key="CREDIT_INFORMATION_ON_FILE"></app-translate>
                </div>
              }
              <!-- DOB -->
              @if (!dobNone() && showDobField()) {
                <div class="col-12 md:col-6">
                  <div class="flex flex-column flex-1">
                    <label htmlFor="dob" [ngClass]="{'form-label' : true, 'required' : dobRequired()}">
                      <app-translate key="DATE_OF_BIRTH"></app-translate>
                      @if (!dobRequired()) {
                        <span class="font-light">&nbsp;<app-translate
                        key="OPTIONAL"></app-translate></span>
                      }
                    </label>
                    <div class="flex align-items-center">
                      <p-password formControlName="dob" autocomplete="dob" [feedback]="false"
                        [placeholder]="languageService.getTranslation('DATE_FORMAT')" class="w-full"
                        styleClass="skinny w-full" [toggleMask]="true" [maxLength]="10" appDate
                        (onFocus)="sendCustomerInputMessage('date of birth')" />
                    </div>
                    <sp-control-error [parameters]="[languageService.getTranslation('DATE_OF_BIRTH')]"
                                [control]="creditInfoGroup.controls['dob']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DOB')},
                            {key : 'futureDate', message : languageService.getTranslation('DOB_FUTURE_ERROR')},
                            {key : 'minimumAge', message : languageService.getTranslation('DOB_AGE_ERROR')}]">
                    </sp-control-error>
                  </div>
                </div>
              }
              <ng-container [ngTemplateOutlet]="ssnGroupTemplate"></ng-container>
              <ng-container [ngTemplateOutlet]="idTypeTemplate"></ng-container>
              @if (conditionalCheckBoxVisible() && showSSNField()) {
                <div class="col-12 flex flex-row gap-2">
                  <p-checkbox inputId="ssnConsent" formControlName="ssnConsent" [binary]="true"
                    (onFocus)="sendCustomerInputMessage('Customer is checking photo id consent', false)" />
                  <label for="ssnConsent" class="text-base font-light mb-0">
                    <app-translate key="USE_PHOTO_ID"></app-translate>
                  </label>
                </div>
              }
              <p-divider></p-divider>
            </div>
          }
          <!-- service address Form -->
          @if (allowBillingAddressChange() && showBillingAddressField()) {
            <div class="flex flex-column gap-3" formGroupName="serviceAddressGroup"
              >
              <div class="title text-base font-semibold pt-3">{{ alternateAddressTitle() | translate }}</div>
              <div class="col-12 flex flex-row gap-2 align-content-center">
                <p-checkbox inputId="useServiceAddress" formControlName="useServiceAddress" [binary]="true" />
                <label for="useServiceAddress" class="text-base font-light mb-0">
                  <app-translate key="USE_SERVICE_ADDRESS"></app-translate>
                </label>
              </div>
              @if (!serviceAddressGroup.controls['useServiceAddress'].value) {
                <div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column flex-1">
                      <label htmlFor="streetAddress"
                        [ngClass]="{'form-label': true, 'required': !serviceAddressGroup.get('useServiceAddress')?.value}">
                        <app-translate key="STREET_ADDRESS"></app-translate>
                      </label>
                      <div class="flex align-items-stretch">
                        <p-autoComplete #autoComplete formControlName="serviceAddress"
                          [suggestions]="filteredAddresses" class="w-full sara-service-address"
                          [inputStyleClass]="'w-full skinny-select'" [styleClass]="'w-full'"
                          (completeMethod)="filterAddress($event)" (onSelect)="onAddressSelect($event)"
                          [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                          [placeholder]="'ENTER_ADDRESS' | translate" (onClear)="clearAddressSection()"
                          (onFocus)="sendCustomerInputMessage('service address')" [size]="'small'">
                        </p-autoComplete>
                      </div>
                      <div>
                        <sp-control-error [parameters]="['STREET_ADDRESS' | translate]"
                        [control]="serviceAddressGroup.controls['serviceAddress']"></sp-control-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-3">
                    <div class="flex flex-column flex-1">
                      <label htmlFor="zipCode"
                        [ngClass]="{'form-label': true, 'required': !serviceAddressGroup.get('useServiceAddress')?.value}">
                        <app-translate key="ZIP_CODE"></app-translate>
                      </label>
                      <div>
                        <p-inputMask #zipCodeInput type="tel" [autoClear]="false" mask="99999?-9999"
                          formControlName="zipCode" [placeholder]="'ENTER_ZIP_CODE' | translate"
                          styleClass="w-full mb-1 skinny" (onBlur)="validateAddress()"
                        (onFocus)="sendCustomerInputMessage('zip code')"></p-inputMask>
                      </div>
                      <sp-control-error [parameters]="['ZIP_CODE' | translate]"
                        [control]="serviceAddressGroup.controls['zipCode']"
                      [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_ZIP' | translate}]"></sp-control-error>
                    </div>
                  </div>
                  <div class="col-12 md:col-3">
                    <div class="flex flex-column flex-1">
                      <label htmlFor="city"
                        [ngClass]="{'form-label': true, 'required': !serviceAddressGroup.get('useServiceAddress')?.value}">
                        <app-translate key="CITY"></app-translate>
                      </label>
                      <div class="flex align-items-center">
                        <input type="text" [placeholder]="'CITY' | translate" pInputText
                          (focus)="sendCustomerInputMessage('city')" formControlName="city"
                          class=" w-full flex-1 mb-0 skinny sara-error" />
                      </div>
                      <sp-control-error [parameters]="['CITY' | translate]"
                        [control]="serviceAddressGroup.controls['city']"
                      [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_CITY' | translate}]"></sp-control-error>
                    </div>
                  </div>
                  <div class="col-12 md:col-3">
                    <div class="flex flex-column flex-1">
                      <label htmlFor="state"
                        [ngClass]="{'form-label': true, 'required': !serviceAddressGroup.get('useServiceAddress')?.value}">
                        <app-translate key="STATE"></app-translate>
                      </label>
                      <div class="flex align-items-center">
                        <p-select [options]="states" formControlName="state" optionLabel="abbreviation"
                          [placeholder]="'SELECT_STATE' | translate" class="w-full"
                          styleClass="skinny w-full" [filter]="true" filterBy="abbreviation"
                          optionValue="abbreviation" (onFocus)="sendCustomerInputMessage('state')">
                          <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div>{{ selectedOption.abbreviation }}</div>
                          </ng-template>
                        </p-select>
                      </div>
                      <sp-control-error [parameters]="['STATE' | translate]"
                        [control]="serviceAddressGroup.controls['state']"
                      [messagesParameters]="[{key : 'pattern', message : 'SELECT_VALID_STATE' | translate}]"></sp-control-error>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="flex flex-row">
                      <div class="mr-3 flex">
                        <p-button #showFullAddressBtn class="text-decoration-none"
                          [styleClass]="'pr-0 text-decoration-none outline-none pl-0'"
                          icon="pi pi-map-marker" (onClick)="showFullAddress = !showFullAddress"
                        [label]="'SHOW_FULL_ADDRESS' | translate" [link]="true" size="small"></p-button>
                        <i [ngClass]="{'pi-angle-up': showFullAddress, 'pi-angle-down': !showFullAddress, 'pi pt-2 color-sara-blue': true }"
                          (click)="showFullAddress = !showFullAddress"
                        (keyup)="showFullAddress = !showFullAddress" tabindex="0"></i>
                      </div>
                    </div>
                  </div>
                  @if (showFullAddress) {
                    <div class="col-12">
                      <ng-container>
                        <div class="mt-2">
                          <div class="flex flex-column md:flex-row gap-3">
                            <div class="pr-2 flex flex-column">
                              <label htmlFor="unitType" class="form-label"><app-translate
                              key="TYPE"></app-translate></label>
                              <p-select formControlName="unitType" [options]="unitTypes"
                                [optionLabel]="'label'" [optionValue]="'value'"
                                [placeholder]="'SELECT_TYPE' | translate"
                                [styleClass]="'skinny-select w-11rem'"
                                (onFocus)="sendCustomerInputMessage('unit type')" />
                            </div>
                            <div class="flex flex-column">
                              <label htmlFor="unitNumber" class="form-label"><app-translate
                              key="NUMBER"></app-translate></label>
                              <input type="text" [placeholder]="'ENTER_NUMBER' | translate" pInputText
                                formControlName="unitNumber" class="mb-1 skinny"
                                (focus)="sendCustomerInputMessage('unit number')" />
                            </div>
                          </div>
                          @if (!displayStructureType) {
                            <div class="flex flex-column">
                              <p-button icon="pi-plus-sara" [label]="'ADD_STRUCTURE_TYPE' | translate"
                                [link]="true"
                                styleClass="outline-none text-decoration-none text-sm font-light pl-0 mr-8 pr-8"
                              (onClick)="displayStructureType = !displayStructureType"></p-button>
                            </div>
                          }
                          @if (displayStructureType) {
                            <div class="mt-3 flex flex-column md:flex-row gap-3">
                              <div class="mr-2 flex flex-column flex-shrink-0">
                                <label htmlFor="structureType" class="form-label">
                                  <app-translate key="STRUCTURE"></app-translate>
                                </label>
                                <p-select formControlName="structureType" [options]="structureTypes"
                                  [placeholder]="'SELECT_STRUCTURE' | translate"
                                  [styleClass]="'skinny-select flex-shrink-0 w-11rem'"
                                  (onFocus)="sendCustomerInputMessage('structure type')" />
                              </div>
                              <div class="flex flex-column">
                                <label htmlFor="structureNumber" class="form-label">
                                  <app-translate key="NUMBER"></app-translate>
                                </label>
                                <div class="flex flex-row">
                                  <input type="text" [placeholder]="'ENTER_NUMBER' | translate" pInputText
                                    formControlName="structureNumber" class="mb-1 skinny"
                                    (focus)="sendCustomerInputMessage('structure number')" />
                                  <p-button icon="pi pi-minus-circle" [label]="'REMOVE' | translate"
                                    [link]="true"
                                    styleClass="outline-none text-decoration-none text-sm font-light pl-3 mr-8 pr-8"
                                  (onClick)="removeStructure()"></p-button>
                                </div>
                              </div>
                            </div>
                          }
                          @if (displayStructureType && !displayFloor) {
                            <div class="flex flex-column">
                              <p-button icon="pi-plus-sara" [label]="'ADD_FLOOR' | translate" [link]="true"
                                styleClass="outline-none text-decoration-none text-sm font-light pl-0 mr-8 pr-8"
                              (onClick)="displayFloor = !displayFloor"></p-button>
                            </div>
                          }
                          @if (displayFloor) {
                            <div class="mt-3 flex flex-column md:flex-row">
                              <div class="pr-2 flex flex-column">
                                <label htmlFor="floor" class="form-label">
                                  <app-translate key="FLOOR_NUMBER"></app-translate>
                                </label>
                                <div class="flex flex-row">
                                  <input type="text" [placeholder]="'ENTER_FLOOR_NUMBER' | translate"
                                    pInputText formControlName="floor" class="mb-1 skinny"
                                    (focus)="sendCustomerInputMessage('floor number')" />
                                  <p-button icon="pi pi-minus-circle" [label]="'REMOVE' | translate"
                                    [link]="true"
                                    styleClass="outline-none text-decoration-none text-sm font-light pl-3 mr-8 pr-8"
                                  (onClick)="removeFloor()"></p-button>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </ng-container>
                    </div>
                  }
                </div>
              }
              @if (serviceAddressGroup.controls['useServiceAddress'].value) {
                <div class="col-12">
                  <div class="flex flex-column flex-1">
                    <label htmlFor="serviceAddressAsBillingAddress"
                      class="font-bold text-sm mb-0"><app-translate
                    key="SERVICE_ADDRESS_AS_BILLING_ADDRESS"></app-translate></label>
                    <div class="flex align-items-center">
                      <span class="uppercase pt-2 text-base font-light">{{serviceAddress}}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </sp-form-wrapper>
      </fieldset>
    </div>
  }
  <div>
    <div class="mb-3">
      <p-button [label]="languageService.getTranslation('SUBMIT')" [disabled]="!isConsentAgreed"
        (onClick)="submitClicked()" styleClass="p-button-lg w-full p-button-primary" />
    </div>
    <div class="mb-3">
      <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
        (onClick)="onCancelClick()" />
    </div>
    <div>
      <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </div>
  </div>
</div>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>

<ng-template #ssnGroupTemplate>
  @if (creditInformationForm && fullSsnVisible() && showSSNField()) {
    <ng-container [formGroup]="creditInformationForm">
      <div class="col-12 md:col-6" formGroupName="ssnGroup">
        <div class="flex flex-column flex-1">
          <label htmlFor="ssn"
            [ngClass]="{'form-label' : true, 'required' : (this.fullSsnConditional() || this.fullSsnRequired()) && !ssnConsent.value }">
            <app-translate key="SOCIAL_SECURITY_NUMBER"></app-translate>
            @if (fullSsnOptional()) {
              <span class="font-light">&nbsp;<app-translate
              key="OPTIONAL"></app-translate></span>
            }
          </label>
          <div class="flex align-items-center">
            <p-password formControlName="ssn" [autocomplete]="'ssn'" [feedback]="false"
              [placeholder]="languageService.getTranslation('SSN_FORMAT')" class="w-full"
              styleClass="skinny w-full" [toggleMask]="true"
              (onFocus)="sendCustomerInputMessage('social security number')" [maxlength]="9" [maxLength]="9"
              [disabled]="ssnConsent.value || ssnGroup.controls['noSsnCheckbox'].value" appNumericOnly />
          </div>
          <sp-control-error [parameters]="[languageService.getTranslation('SOCIAL_SECURITY_NUMBER')]"
            [control]="ssnGroup.controls['ssn']"
          [messagesParameters]="[{key : 'pattern', message : languageService.getTranslation('ENTER_VALID_SSN')}]"></sp-control-error>
          @if (fullSsnOptional()) {
            <div class="flex flex-row gap-2 mt-2">
              <p-checkbox inputId="noSsnCheckbox" formControlName="noSsnCheckbox" [binary]="true"
                (onFocus)="sendCustomerInputMessage('Customer is checking no SSN provided', false)" />
              <label for="noSsnCheckbox" class="text-base font-light mb-0">
                <app-translate key="NO_SSN_PROVIDED"></app-translate>
              </label>
            </div>
          }
        </div>
      </div>
    </ng-container>
  }

  @if (creditInformationForm && last4SsnVisible() && showSSNField()) {
    <ng-container [formGroup]="creditInformationForm">
      <div class="col-12 md:col-6" formGroupName="ssnGroup">
        <div class="flex flex-column flex-1">
          <label htmlFor="last4Ssn"
            [ngClass]="{'form-label' : true, 'required' : (last4SsnConditional() || last4SsnRequired())&& !ssnConsent.value }">
            <app-translate key="LAST_4_SSN"></app-translate>
          </label>
          <div class="flex align-items-center">
            <p-password formControlName="last4Ssn" [autocomplete]="'last4Ssn'" [feedback]="false"
              [placeholder]="languageService.getTranslation('LAST_4_SSN_FORMAT')" class="w-full"
              styleClass="skinny w-full" [toggleMask]="true"
              (onFocus)="sendCustomerInputMessage('last 4 social security number')"
              [disabled]="ssnConsent.value" [maxLength]="4" appNumericOnly />
          </div>
          <sp-control-error [parameters]="[languageService.getTranslation('LAST_4_SSN')]"
            [control]="ssnGroup.controls['last4Ssn']"
          [messagesParameters]="[{key : 'pattern', message : languageService.getTranslation('ENTER_VALID_LAST_4_SSN')}]"></sp-control-error>
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #idTypeTemplate>
  @if (creditInformationForm && (photoIdVisible() || ssnConsent.value) && showPhotoIdField()) {
    <ng-container
      [formGroup]="creditInformationForm">
      <ng-container formGroupName="idTypeGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="idType"
              [ngClass]="{'form-label' : true, 'required' : photoIdRequired() || ssnConsent.value }">
              <app-translate key="ID_TYPE"></app-translate>
              @if (photoIdOptional()) {
                <span class="font-light">&nbsp;<app-translate
                key="OPTIONAL"></app-translate></span>
              }
            </label>
            <div class="flex align-items-center">
              <p-select [options]="idTypes" formControlName="idType"
                [placeholder]="languageService.getTranslation('SELECT_STATE')" class="w-full"
                styleClass="skinny w-full" (onFocus)="sendCustomerInputMessage('id type')">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div>{{ selectedOption }}</div>
                </ng-template>
              </p-select>
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ID_TYPE')]"
            [control]="idTypeGroup.controls['idType']"></sp-control-error>
          </div>
        </div>
        @if (authUserList().length > 0) {
          <div class="col-12 md:col-6">
            <div class="flex flex-column flex-1">
              <label htmlFor="idName" [ngClass]="{'form-label' : true, 'required' : authUserList().length > 0 }">
                <app-translate key="AUTH_USER"></app-translate>
              </label>
              <div class="flex align-items-center">
                <p-select id="idName" [options]="authUserList()"
                  [placeholder]="languageService.getTranslation('SELECT_AUTH_USER')" class="w-full"
                styleClass="skinny w-full" formControlName="idName"></p-select>
              </div>
              <sp-control-error [parameters]="[languageService.getTranslation('AUTH_USER')]"
              [control]="idTypeGroup.controls['idName']"></sp-control-error>
            </div>
          </div>
        }
        @if(selectedIdType){
          @switch (selectedIdType) {
            @case ('Driver’s License') {
              <ng-container [ngTemplateOutlet]="dlGroupTemplate"></ng-container>
            }
            @case ('State Issued ID') {
              <ng-container [ngTemplateOutlet]="stateGroupTemplate"></ng-container>
            }
            @case ('U.S. Military ID') {
              <ng-container [ngTemplateOutlet]="militaryGroupTemplate"></ng-container>
            }
            @case ('U.S. Passport') {
              <ng-container [ngTemplateOutlet]="passportGroupTemplate"></ng-container>
            }
            @case ('Foreign Government ID') {
              <ng-container [ngTemplateOutlet]="foreignGovernmentIdGroupTemplate"></ng-container>
            }
            @default {
              <app-translate key="ID_TYPE_NOT_HANDLED"></app-translate>
            }
          }
        }
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #dlGroupTemplate>
  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container formGroupName="dlGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="issuingState" class="form-label required"><app-translate
            key="ISSUING_STATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-select [options]="states" formControlName="issuingAuthority" optionLabel="abbreviation"
                optionValue="abbreviation" [placeholder]="languageService.getTranslation('SELECT_STATE')"
                class="w-full" styleClass="skinny w-full" [filter]="true" filterBy="abbreviation"
                (onFocus)="sendCustomerInputMessage('id issuing state')">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div>{{ selectedOption.abbreviation }}</div>
                </ng-template>
              </p-select>
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ISSUING_STATE')]"
            [control]="dlGroup.controls['issuingAuthority']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
                    <ng-container *ngTemplateOutlet="idNumberControlTemplate;
                        context : {
                            formcontrol : dlGroup.controls['idNumber'] ,
                            groupName: 'dlGroup',
                            labelId: 'idNumber' ,
                            labelName : languageService.getTranslation('ID_NUMBER'),
                            selectedState : selectedState }">
            </ng-container>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="expirationDate" class="form-label required"><app-translate
            key="EXPIRATION_DATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="expirationDate" autocomplete="dlExpirationDate" [feedback]="false"
                [placeholder]="languageService.getTranslation('DATE_FORMAT')" [maxLength]="10"
                class="w-full" styleClass="skinny w-full" [toggleMask]="true" appDate
                (onFocus)="sendCustomerInputMessage('id expiring date')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('EXPIRATION_DATE')]"
                        [control]="dlGroup.controls['expirationDate']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DATE')},
                            {key : 'expiredDate', message : languageService.getTranslation('EXPIRATION_DATE_ERROR')}
                        ]"></sp-control-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #stateGroupTemplate>
  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container formGroupName="stateGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="issuingState" class="form-label required"><app-translate
            key="ISSUING_STATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-select [options]="states" formControlName="issuingAuthority" optionLabel="abbreviation"
                optionValue="abbreviation" [placeholder]="languageService.getTranslation('SELECT_STATE')"
                class="w-full" styleClass="skinny w-full" [filter]="true" filterBy="abbreviation"
                (onFocus)="sendCustomerInputMessage('id issuing state')">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div>{{ selectedOption.abbreviation }}</div>
                </ng-template>
              </p-select>
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ISSUING_STATE')]"
            [control]="stateGroup.controls['issuingAuthority']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="ssn" class="form-label required"><app-translate
            key="ID_NUMBER"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="idNumber" appAlphaNumeric [autocomplete]="'dlIdNumber'"
                [feedback]="false" class="w-full" styleClass="skinny w-full" [toggleMask]="true"
                (onFocus)="sendCustomerInputMessage('id number')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ID_NUMBER')]"
            [control]="stateGroup.controls['idNumber']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="expirationDate" class="form-label required"><app-translate
            key="EXPIRATION_DATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="expirationDate" autocomplete="dlExpirationDate" [feedback]="false"
                [placeholder]="languageService.getTranslation('DATE_FORMAT')" [maxLength]="10"
                class="w-full" styleClass="skinny w-full" [toggleMask]="true" appDate
                (onFocus)="sendCustomerInputMessage('id expiring date')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('EXPIRATION_DATE')]"
                        [control]="stateGroup.controls['expirationDate']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DATE')},
                            {key : 'expiredDate', message : languageService.getTranslation('EXPIRATION_DATE_ERROR')}
                        ]"></sp-control-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #militaryGroupTemplate>
  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container formGroupName="militaryIdGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="ssn" class="form-label required"><app-translate
            key="ID_NUMBER"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="idNumber" appAlphaNumeric [autocomplete]="'dlIdNumber'"
                [feedback]="false" class="w-full" styleClass="skinny w-full" [toggleMask]="true"
                (onFocus)="sendCustomerInputMessage('id number')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ID_NUMBER')]"
            [control]="militaryIdGroup.controls['idNumber']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="expirationDate" class="form-label required"><app-translate
            key="EXPIRATION_DATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="expirationDate" autocomplete="dlExpirationDate" [feedback]="false"
                [placeholder]="languageService.getTranslation('DATE_FORMAT')" [maxLength]="10"
                class="w-full" styleClass="skinny w-full" [toggleMask]="true"
                (onFocus)="sendCustomerInputMessage('id expiring date')" appDate />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('EXPIRATION_DATE')]"
                        [control]="militaryIdGroup.controls['expirationDate']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DATE')},
                            {key : 'expiredDate', message : languageService.getTranslation('EXPIRATION_DATE_ERROR')}
                        ]"></sp-control-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #passportGroupTemplate>
  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container formGroupName="passportGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="ssn" class="form-label required"><app-translate
            key="ID_NUMBER"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="idNumber" appAlphaNumeric [autocomplete]="'dlIdNumber'"
                [feedback]="false" class="w-full" styleClass="skinny w-full" [toggleMask]="true"
                (onFocus)="sendCustomerInputMessage('id number')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ID_NUMBER')]"
            [control]="passportGroup.controls['idNumber']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="expirationDate" class="form-label required"><app-translate
            key="EXPIRATION_DATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="expirationDate" autocomplete="dlExpirationDate" [feedback]="false"
                [placeholder]="languageService.getTranslation('DATE_FORMAT')" [maxLength]="10"
                class="w-full" styleClass="skinny w-full" [toggleMask]="true" appDate
                (onFocus)="sendCustomerInputMessage('id expiring date')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('EXPIRATION_DATE')]"
                        [control]="passportGroup.controls['expirationDate']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DATE')},
                            {key : 'expiredDate', message : languageService.getTranslation('EXPIRATION_DATE_ERROR')}
                        ]"></sp-control-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #foreignGovernmentIdGroupTemplate>
  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container formGroupName="foreignGovernmentIdGroup">
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="issuingAuthority" class="form-label required"><app-translate
            key="ISSUING_AUTHORITY"></app-translate></label>
            <div class="flex align-items-center">
              <p-select [options]="countries" formControlName="issuingAuthority" optionLabel="name"
                [placeholder]="languageService.getTranslation('SELECT_COUNTRY')" class="w-full"
                optionValue="name" styleClass="skinny w-full" [filter]="true" filterBy="name"
                (onFocus)="sendCustomerInputMessage('id issuing state')">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div>{{ selectedOption.name }}</div>
                </ng-template>
                <ng-template pTemplate="item" let-selectedOption>
                  <div>{{ selectedOption.name }}</div>
                </ng-template>
              </p-select>
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ISSUING_AUTHORITY')]"
            [control]="foreignGovernmentIdGroup.controls['issuingAuthority']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="ssn" class="form-label required"><app-translate
            key="ID_NUMBER"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="idNumber" appAlphaNumeric [autocomplete]="'dlIdNumber'"
                [feedback]="false" class="w-full" styleClass="skinny w-full" [toggleMask]="true"
                (onFocus)="sendCustomerInputMessage('id number')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ID_NUMBER')]"
            [control]="foreignGovernmentIdGroup.controls['idNumber']"></sp-control-error>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="flex flex-column flex-1">
            <label htmlFor="expirationDate" class="form-label required"><app-translate
            key="EXPIRATION_DATE"></app-translate></label>
            <div class="flex align-items-center">
              <p-password formControlName="expirationDate" autocomplete="dlExpirationDate" [feedback]="false"
                [placeholder]="languageService.getTranslation('DATE_FORMAT')" [maxLength]="10"
                class="w-full" styleClass="skinny w-full" [toggleMask]="true" appDate
                (onFocus)="sendCustomerInputMessage('id expiring date')" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('EXPIRATION_DATE')]"
                        [control]="foreignGovernmentIdGroup.controls['expirationDate']" [messagesParameters]="[
                            {key : 'pattern', message : languageService.getTranslation('ENTER_VALID_DATE')},
                            {key : 'expiredDate', message : languageService.getTranslation('EXPIRATION_DATE_ERROR')}
                        ]"></sp-control-error>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }
</ng-template>

<ng-template #idNumberControlTemplate let-formcontrol="formcontrol" let-groupName="groupName" let-labelId="labelId"
  let-labelName="labelName" let-selectedState="selectedState">

  @if (creditInformationForm) {
    <ng-container [formGroup]="creditInformationForm">
      <ng-container [formGroupName]="groupName">
        <label [htmlFor]="labelId" class="form-label required">{{labelName}}</label>
        <div class="flex align-items-center">
          <p-password formControlName="idNumber" appAlphaNumeric [autocomplete]="'dlIdNumber'" [feedback]="false"
            class="w-full" styleClass="skinny w-full" [pTooltip]="currentStateTooltip" [toggleMask]="true"
            (onFocus)="sendCustomerInputMessage('id number')" />
        </div>
        @if (selectedState) {
          <sp-control-error [parameters]="[languageService.getTranslation('ID_NUMBER')]"
            [control]="formcontrol"
          [messagesParameters]="[{key : 'pattern', message : selectedState.errorMessage!}]"></sp-control-error>
        }
      </ng-container>
    </ng-container>
  }
</ng-template>
